module.exports = __webpack_public_path__ + "img/code-obg.fc12391c.png";